import { useEffect, useRef } from "react";
import {
  GameStatus,
  useBingoGameStore,
} from "@/plugins/bingo/state/bingoGameStore";

/**
 * useAutoMode
 *
 * When the game is running in Auto mode and status is IN_PROGRESS,
 * ticks the draw engine every `autoInterval` seconds by calling `callNext()`.
 *
 * Any other status (Paused, Reviewing, Announcing Winner, Idle, Summary)
 * cancels the tick.
 */
export function useAutoMode() {
  const mode = useBingoGameStore((s) => s.mode);
  const autoInterval = useBingoGameStore((s) => s.autoInterval);
  const status = useBingoGameStore((s) => s.status);
  const callNext = useBingoGameStore((s) => s.callNext);
  const timerRef = useRef(null);

  useEffect(() => {
    const clear = () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };

    if (mode !== "auto" || status !== GameStatus.IN_PROGRESS) {
      clear();
      return clear;
    }
    const ms = Math.max(1, autoInterval) * 1000;
    timerRef.current = setInterval(() => {
      callNext();
    }, ms);
    return clear;
  }, [mode, autoInterval, status, callNext]);
}
